import { render, staticRenderFns } from "./payrollPayment.vue?vue&type=template&id=2e45a0be&scoped=true"
import script from "./payrollPayment.vue?vue&type=script&lang=js"
export * from "./payrollPayment.vue?vue&type=script&lang=js"
import style0 from "./payrollPayment.vue?vue&type=style&index=0&id=2e45a0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45a0be",
  null
  
)

export default component.exports